module.exports = __webpack_public_path__ + "img/cxample_20.d0b39a63.png";